<template>
  <div class="text-wrapper">
    <!-- 搜索项 -->
    <div class="search-wrapper flex">
      <div class="input-wrapper flex">
        <p>教师姓名：</p>
        <el-input
          v-model="tableInfo.query.teacherName"
          placeholder="请输入教师姓名">
        </el-input>
      </div>
      <div class="btn-wrapper">
        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table">
      <el-button type="primary" @click="addInfo">新建</el-button>
      <teacher-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="true"
        :api="getListPage"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-teacherPropagateUrl="scope">
          <img
            :src="scope.row.teacherPropagateUrl"
            v-if="scope.row.teacherPropagateUrl"
            style="height:36px;"
            @click="handleShow(scope.row.teacherPropagateUrl)">
          <span v-else> - </span>
        </template>
        <template v-slot:col-teacherUrl="scope">
          <img
            :src="scope.row.teacherUrl"
            v-if="scope.row.teacherUrl"
            style="height:36px;"
            @click="handleShow(scope.row.teacherUrl)">
          <span v-else> - </span>
        </template>
        <template v-slot:col-recommendState="scope">
          <p>{{ scope.row.recommendState === 2 ? '已推荐' : '未推荐' }}</p>
        </template>
        <template v-slot:col-state="scope">
          <p>{{ scope.row.state === 1 ? '已停用' : '已启用' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            :loading="scope.data.row[scope.data.item.loading]"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.state === 2 ? '停用' : '启用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-recommend="scope">
          <el-button
            v-if="scope.data.row.state === 2"
            :type="'text'"
            :loading="scope.data.row[scope.data.item.loading]"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.recommendState === 2 ? '取消推荐' : '推荐' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.state === 1"
            :type="'text'"
            :loading="scope.data.row[scope.data.item.loading]"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </teacher-table>
    </div>
    <teacher-dialog
      ref="teacherDialog"
      :teacher-dialog-visible="teacherDialogVisible"
      @close="handleCloseDialog"
      @submit="onSubmit">
    </teacher-dialog>
    <preview :photo-shows="showPreview" :url="previewUrl" @showSrue="showPreview = false"></preview>
  </div>
</template>
<script>
import TeacherTable from '@/components/PublicTable';
import TeacherDialog from './components/teacherDialog';
import Preview from './components/preview';
import { getListPage, addTeacher, updateState, updateRecommendState, delTeacher, updateTeacher } from '@/api/api.js';
export default {
  components: {
    TeacherTable,
    TeacherDialog,
    Preview
  },
  data() {
    return {
      getListPage,
      nameList: [],
      teacherDialogVisible: false,
      showPreview: false,
      previewUrl: '',
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {
          teacherName: ''
        },
        fieldList: [
          { label: '排序号', value: 'sortNum' },
          { label: '教师姓名', value: 'teacherName'},
          { label: '名师宣传图片', type: 'slot', value: 'teacherPropagateUrl' },
          { label: '教师照片', type: 'slot', value: 'teacherUrl' },
          { label: '是否推荐', type: 'slot', value: 'recommendState' },
          { label: '状态', type: 'slot', value: 'state' }
        ],
        handle: {
          label: '操作',
          width: '200',
          btList: [
            { label: '编辑', type: 'text', icon: '', event: 'edit', show: true },
            { label: '停用', type: 'text', icon: '', event: 'state', show: true, slot: true },
            { label: '推荐', type: 'text', icon: '', event: 'recommend', show: true, slot: true },
            { label: '删除', type: 'text', icon: '', event: 'delete', show: true, slot: true },
          ]
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    handleShow(url) {
      this.showPreview = true;
      this.previewUrl = url;
    },
    // 提交表单
    onSubmit(data) {
      if (data.isEdit) {
        updateTeacher(data.form).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.handleCloseDialog();
            this.getList();
            this.$message.success('编辑成功');
          } else {
            this.$message.error(message);
          }
        })
      } else {
        addTeacher(data.form).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.handleCloseDialog();
            this.getList();
            this.$message.success('保存成功');
          } else {
            this.$message.error(message);
          }
        })
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.teacherDialogVisible = false;
    },
    // 展示弹窗
    addInfo() {
      this.teacherDialogVisible = true;
      this.$refs.teacherDialog.init();
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random();
    },
    // 重置
    reset() {
      this.tableInfo.query.teacherName = '';
      this.getList();
    },
    // table操作
    handleClick(event, row) {
      if (event === 'state') {
        updateState({
          id: row.id
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.state === 2 ? '停用成功' : '发布成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else if (event === 'recommend') {
        updateRecommendState({
          id: row.id
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.recommendState === 2 ? '取消推荐成功' : '推荐成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else if (event === 'delete') {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delTeacher({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      } else {
        this.teacherDialogVisible = true;
        this.$refs['teacherDialog'].init(row);
      }
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
  },
}
</script>
<style lang="scss" scoped>
.text-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .search-wrapper {
    width: 100%;
    .input-wrapper {
      .el-input {
        width: 200px;
        margin-left: 10px;
      }
    }
    .btn-wrapper {
      margin-left: 30px;
    }
  }

  .table {
    margin-top: 20px;
    .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>